import type { DocumentField } from '@pleased-npm/fe-customisation';

/**
 * Get the value from a DocumentField
 */
export const getFieldValue = <T = string>(field: DocumentField): T => {
  return field.value as T;
};
